document.addEventListener("DOMContentLoaded", () => {
  const updateBar = (cart) => {
    const bar = document.getElementById("free-shipping-bar");
    if (!bar) return;

    const threshold = Number(bar.dataset.threshold);
    const total = cart.total_price;
    const remain = Math.max(threshold - total, 0);
    const percent = Math.min(Math.round((total / threshold) * 100), 100);

    const progressEl = bar.querySelector("[data-progress]");
    const msgEl = bar.querySelector("[data-message]");
    if (!progressEl || !msgEl) return;

    progressEl.style.width = `${percent}%`;

    const msg =
      total >= threshold
        ? `🎉 You've got free shipping!`
        : `Spend ${theme.Currency.formatMoney(
            remain,
            theme.settings.moneyFormat
          )} more for free shipping!`;

    msgEl.innerHTML = msg;
  };

  const waitForThemeCartForm = () => {
    if (theme?.CartForm?.prototype?.cartMarkup) {
      const original = theme.CartForm.prototype.cartMarkup;
      theme.CartForm.prototype.cartMarkup = function (html) {
        original.call(this, html);
        fetch("/cart.js")
          .then((res) => res.json())
          .then(updateBar)
          .catch(() => {});
      };
    } else {
      setTimeout(waitForThemeCartForm, 200);
    }
  };

  waitForThemeCartForm();
});
